var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBatteryHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 10.5V9.5M7.4 13H11.1C11.9401 13 12.3601 13 12.681 12.8365C12.9632 12.6927 13.1927 12.4632 13.3365 12.181C13.5 11.8601 13.5 11.4401 13.5 10.6V9.4C13.5 8.55992 13.5 8.13988 13.3365 7.81901C13.1927 7.53677 12.9632 7.3073 12.681 7.16349C12.3601 7 11.9401 7 11.1 7H7.4C6.55992 7 6.13988 7 5.81901 7.16349C5.53677 7.3073 5.3073 7.53677 5.16349 7.81901C5 8.13988 5 8.55992 5 9.4V10.6C5 11.4401 5 11.8601 5.16349 12.181C5.3073 12.4632 5.53677 12.6927 5.81901 12.8365C6.13988 13 6.55992 13 7.4 13Z",
    stroke: "#667085",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 8.6C5 8.03995 5 7.75992 5.15441 7.54601C5.29023 7.35785 5.50695 7.20487 5.77351 7.10899C6.07656 7 6.47326 7 7.26667 7H11.2333C12.0267 7 12.4234 7 12.7265 7.10899C12.993 7.20487 13.2098 7.35785 13.3456 7.54601C13.5 7.75992 13.5 8.03995 13.5 8.6V11.4C13.5 11.9601 13.5 12.2401 13.3456 12.454C13.2098 12.6422 12.993 12.7951 12.7265 12.891C12.4234 13 12.0267 13 11.2333 13H7.26667C6.47326 13 6.07656 13 5.77351 12.891C5.50695 12.7951 5.29023 12.6422 5.15441 12.454C5 12.2401 5 11.9601 5 11.4V8.6Z",
    stroke: "#667085",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.24838 9.02264C8.77631 8.63307 7.98911 8.52827 7.39764 8.885C6.80617 9.24173 6.7229 9.83816 7.18738 10.2601C7.48489 10.5303 8.2468 11.0314 8.75617 11.3568C8.92544 11.4649 9.01007 11.519 9.11144 11.5407C9.19859 11.5593 9.29818 11.5593 9.38532 11.5407C9.4867 11.519 9.57133 11.4649 9.7406 11.3568C10.25 11.0314 11.0119 10.5303 11.3094 10.2601C11.7739 9.83816 11.7008 9.23798 11.0991 8.885C10.4975 8.53203 9.72045 8.63307 9.24838 9.02264Z",
    stroke: "#667085",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryHealth);
export default __webpack_public_path__ + "static/media/battery-health.4408c93fd5ceda8493ecf818a5df5029.svg";
export { ForwardRef as ReactComponent };